import "./App.css";
import Home from "./components/Home";
import About from "./components/About";
import Courses from "./components/Courses";
import Navbar from "./components/Navbar";
import Testimonials from "./components/Testimonials";
import ContactUs from "./components/ContactUs";
import Admissions from "./components/Admission";
import Gallery from "./components/Gallery";
import LocateUs from "./components/LocateUs";
import Graph from "./components/ResultGraph";

function App() {
  return (
    <>
      <Navbar />
      <Home />
      <About />
      <Courses />
      <Testimonials />
      <Gallery />
      <Graph />
      <Admissions />
      <LocateUs />
      <ContactUs />
    </>
  );
}

export default App;
